import React from 'react';
import FormAttachment from "../../../library/form/components/FormAttachment"
import FormROValue from "../../../library/form/components/FormROValue1"
import FormLabel from "../../../library/form/components/FormLabel"
import FormLink from "../../../library/form/components/FormLink"
import FormWrapper from "../../../library/form/components/FormWrapper"
import FormButton from "../../../library/form/components/FormActionButton2"
import DocChildActivator from "../../cmn/DocChildActivator";
import SarasTrans from "../../../library/notifications/SarasTrans";
import FormInput from '../../../library/form/components/FormInput';
import FormSearchButton from '../../../library/form/components/FormSearchButton';

const InvGroupItemDetailRow = (props) => {
    const { formObject, rowKey } = props;

    let lineId = formObject.getFormData(rowKey, "", "lineId");
    let itemType = formObject.getFormData(rowKey, "", "itemType");

    return (
        <div className="phChildGroupViewAreaItem phViewContent">
            <div className="phViewImage">
                <FormAttachment formObject={formObject} rowKey={rowKey} imgHeight="50px" action={{ InputType: "i", paramName: "itemImage" }} />
            </div>

            <div className="phViewHeader" >
                <div className="phKeyValueView">
                    <FormROValue format="#" formObject={formObject} rowKey={rowKey} action={{ paramName: "lineNo" }} className="uiBoxItemLineNo" />
                </div>
                <div className="phKeyValueView">
                    <FormROValue format="#" formObject={formObject} rowKey={rowKey} action={{ paramName: "itemType" }} className="uiKey uiSpacerR2" />

                    <FormLink formObject={formObject} rowKey={rowKey} className="uiLink uiSpacerR2"
                        action={{
                            paramName: "itemId",
                            actionId: "show",  actionName: "itemComp",
                            containerKey: "custom",
                            actionParam:{showModeID: "qv"}
                        }}
                        linkProp={{ target: "_blank" }}
                    ></FormLink>
                </div>
                <div className="phKeyValueView">
                    <span className="uiKey">
                        <FormLabel formObject={formObject} rowKey={rowKey} action={{ paramName: "refType" }} value="" />
                    </span>
                    <FormLink formObject={formObject} rowKey={rowKey} className="uiLink"
                        action={{
                            paramName: "refId",
                            actionId: "show",  actionName: "invcomp",
                            containerKey: "popup"
                        }}
                        linkProp={{ target: "_blank" }}
                    ></FormLink>
                </div>
            </div>

            <div className="phViewName">
                <FormROValue format="#" formObject={formObject} rowKey={rowKey} action={{ paramName: "itemName" }} />
            </div>

            <div className="phViewRef" >
                <FormWrapper customWrapper="div" wrapperClass="phKeyValueView" formObject={formObject} rowKey={rowKey} action={{ paramName: "itemChannel" }} >
                    <span className="uiKey">
                        <FormLabel formObject={formObject} rowKey={rowKey} action={{ paramName: "itemChannel" }} value="Channel" />
                    </span>
                    <FormROValue format="#" formObject={formObject} rowKey={rowKey} action={{ paramName: "itemChannel" }} className="uiValue" />
                </FormWrapper>
                <FormWrapper customWrapper="div" wrapperClass="phKeyValueView" formObject={formObject} rowKey={rowKey} action={{ paramName: "stockProfile" }} >
                    <span className="uiKey">
                        <FormLabel formObject={formObject} rowKey={rowKey} action={{ paramName: "stockProfile" }} value="Stock Profile" />
                    </span>
                    <FormROValue format="#" formObject={formObject} rowKey={rowKey} action={{ paramName: "stockProfile" }} className="uiValue" />
                </FormWrapper>
            </div>
            <div className="phViewQty">
                <FormInput formObject={formObject} className="uiInput uiVal40" rowKey={rowKey}
                    action={{ InputType: "input", actionId: "refresh", refreshMode:"dep", paramName: "qty1", actionParam: { formulaSource: "QT1", updateNetAmount: "1", viewCaller:"rowViewer" } }} />
                <FormROValue format="#" formObject={formObject} rowKey={rowKey} action={{ paramName: "uom1" }} />
                {/* <FormWrapper customWrapper="div" wrapperClass="uiInline" formObject={formObject} rowKey={rowKey} action={{ paramName: "itemQty2Container" }} > */}
                    <FormInput formObject={formObject} rowKey={rowKey} className="uiInput uiVal40" roClass="uiSpacerL10"
                        action={{ InputType: "input", actionId: "refresh", refreshMode:"dep", paramName: "qty2", actionParam: { formulaSource: "QT2", updateNetAmount: "1", viewCaller:"rowViewer" } }} />
                    <FormROValue format="#" formObject={formObject} rowKey={rowKey} action={{ paramName: "uom2" }} />
                {/* </FormWrapper> */}
                {/* <FormROValue format="#" formObject={formObject} rowKey={rowKey} action={{ paramName: "itemQty" }} className="uiValue" style={{ display: "block" }} /> */}

                <FormROValue format="#" formObject={formObject} rowKey={rowKey} action={{ paramName: "ccQty" }} className="uiFontSize11 uiBlue" />
                <FormROValue format="#" formObject={formObject} rowKey={rowKey} action={{ paramName: "itemReturn" }} className="uiFontSize11 uiColorRed" />

            </div>
            <div className="phViewCost">
                <FormWrapper formObject={formObject} rowKey={rowKey} action={{ paramName: "costContainer" }} >
                    <div className="phKeyValueView">

                        <span className="uiKey">
                            <FormLabel formObject={formObject} rowKey={rowKey} action={{ paramName: "unitCost" }} value="Price" />
                        </span>
                        <FormROValue format="" formObject={formObject} rowKey={rowKey} action={{ paramName: "unitCost" }} className="uiValue" />
                    </div>
                </FormWrapper>
                <FormWrapper formObject={formObject} rowKey={rowKey} action={{ paramName: "salesContainer" }} >
                    <div className="phKeyValueView">
                        <span className="uiKey">
                            <FormLabel formObject={formObject} rowKey={rowKey} action={{ paramName: "discAmt" }} value="Disc." />
                        </span>
                        <FormROValue format="" formObject={formObject} rowKey={rowKey} action={{ paramName: "discAmt" }} className="uiValue" />
                    </div>
                    <div className="phKeyValueView">
                        <span className="uiKey">
                            <FormLabel formObject={formObject} rowKey={rowKey} action={{ paramName: "sellAmt" }} value="Sell Amt." />
                        </span>

                        <FormROValue format="" formObject={formObject} rowKey={rowKey} action={{ paramName: "sellAmt" }} className="uiValue uiHighlightBlue" />
                    </div>
                    <div className="phKeyValueView">
                        <span className="uiKey">
                            <FormLabel formObject={formObject} rowKey={rowKey} action={{ paramName: "taxAmt" }} value="Tax" />
                        </span>

                        <FormROValue format="" formObject={formObject} rowKey={rowKey} action={{ paramName: "taxAmt" }} />
                    </div>
                    <div className="phKeyValueView" id="otherChargeContainer" >
                        <span className="uiKey">
                            <FormLabel formObject={formObject} rowKey={rowKey} action={{ paramName: "commAmt" }} value="Comm" />
                        </span>

                        <FormROValue format="" formObject={formObject} rowKey={rowKey} action={{ paramName: "commAmt" }} />
                    </div>
                </FormWrapper>
            </div>
            <div className="phViewAction uiActionBlock">
                <DocChildActivator formObject={formObject} rowKey={rowKey}
                        action={{ actionId: "show",  paramName: "childComp", actionParam: {}, containerKey: "popup" }}
                    />
                <FormButton formObject={formObject} rowKey={rowKey}
                    starIcon="edit"
                    onlyIcon={true}
                    tooltip="Edit"
                    starIconClassName="uiColorNeutralAction"
                    className="" 
                    action={{ actionId: "edit", paramName: "editBtn", actionParam: { pathKey: "#pathKey" }, containerKey: "popup" }}
                ></FormButton>
                <FormButton formObject={formObject} rowKey={rowKey}
                    starIcon="clear"
                    onlyIcon={true}
                    tooltip="Delete"
                    starIconClassName="uiColorNegativeAction"
                    className=""
                    action={{ actionId: "del", paramName: "delBtn", actionParam: {}, containerKey: "row" }}
                ></FormButton>

                <FormWrapper formObject={formObject} rowKey={rowKey} action={{ paramName: "sortBtn" }} >
                    <FormSearchButton formObject={formObject} rowKey="" headerKey='sortItemLink' filterKey={itemType.val} btnLabel="Add Sort" hideTxt={true}
                        action={{ actionId: "refresh",  actionParam: { lineId:lineId.val, lineType:"S" } }}
                        className='uiActionButton' 
                    />
                </FormWrapper>
            </div>
            <div className="phViewAlloc">
                <FormWrapper customWrapper="div" formObject={formObject} rowKey={rowKey} action={{ paramName: "autoAllocateContainer" }} >
                    <span className="uiLblInLine">
                        <SarasTrans value="Auto Allocate" />
                    </span>
                    <span className="uiSpacerH5"><SarasTrans value="by Date" /></span>
                    <FormButton formObject={formObject} rowKey={rowKey} tooltip='Oldest First' icon='low' className="uiActionButton uiSpacerR2"
                        action={{ actionId: "refresh", refreshMode:"self", actionParam: { "autoAllocate":1, "sortBy":"date", "sortOrder":"asc" } }}
                        text={<SarasTrans value="Oldest" />} 
                    />
                    <FormButton formObject={formObject} rowKey={rowKey} tooltip='Newest First' icon='high' className="uiActionButton"
                        action={{ actionId: "refresh", refreshMode:"self", actionParam: { "autoAllocate":1, "sortBy":"date", "sortOrder":"desc" } }}
                        text={<SarasTrans value="Newest" />} 
                    />

                    <FormWrapper customWrapper="span" formObject={formObject} rowKey={rowKey} action={{ paramName: "autoAllocatePriceContainer" }} >
                        <span className="uiSpacerH5"><SarasTrans value="by Price: " /></span>
                        <FormButton formObject={formObject} rowKey={rowKey} tooltip='Lowest Price' icon='low' className="uiActionButton uiSpacerR2"
                            action={{ actionId: "refresh", refreshMode:"self", actionParam: { "autoAllocate":1, "sortBy":"price", "sortOrder":"asc" } }}
                            text={<SarasTrans value="Lowest" />} 
                        />
                        <FormButton formObject={formObject} rowKey={rowKey} tooltip='Highest Price' icon='high' className="uiActionButton"
                            action={{ actionId: "refresh", refreshMode:"self", actionParam: { "autoAllocate":1, "sortBy":"price", "sortOrder":"desc" } }}
                            text={<SarasTrans value="Highest" />} 
                        />
                    </FormWrapper>
                </FormWrapper>
            </div>
        </div>
    )
}

export default InvGroupItemDetailRow